<div class="location">
    <div>{{slicName}}</div>
    <div title="{{customName}}">{{customName}}</div>
    <div title="{{address | replace: emptyAddressRegex}}">{{address | replace: emptyAddressRegex}}</div>
</div>